<template>
  <el-container class="eventDispatch">
    <el-card class="tree-card" :body-style="treeCard">
      <h-table
        ref="tableRef"
        v-model:columns="columns"
        :method="suspectedLeave"
        :params="tableParams"
        :autoload="false"
        @handleClick="handleClick"
        @select="hzTableSelect"
      >
        <template #personName="{ row }">
          <div class="table-role">
            <span>{{ row.faceInfo && row.faceInfo.personName }}</span>
          </div>
        </template>
        <template #carImg="{ row }">
          <el-image
            v-if="row.faceInfo"
            class="table-img"
            style="height: 100px"
            :src="imgURL + row.faceInfo.fileUrl"
          ></el-image>
          <span v-else>暂无</span>
        </template>
      </h-table>
    </el-card>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  watch,
  inject,
  nextTick,
} from "vue";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import { suspectedLeave } from "@/api/monitorManagement/keyControl.js";
// import _ from "lodash";
export default defineComponent({
  name: "eventDispatch",
  props: {
    outList: {
      type: Object,
    },
  },
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        endDate: "",
        startDate: "",
        libraryIds: "",
      },
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "预警日期",
          prop: "snapDate", // sex
        },
        {
          label: "姓名",
          slot: "personName",
        },
        {
          label: "未出现天数",
          prop: "notOutDays", // sex
        },
        {
          label: "照片",
          slot: "carImg", // sex
        },
      ],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    const ruleInfo = inject("ruleInfo");
    watch(
      () => ruleInfo,
      () => {
        if (ruleInfo.endDate || ruleInfo.startDate || ruleInfo.libraryIds) {
          state.tableParams.endDate = ruleInfo.endDate;
          state.tableParams.startDate = ruleInfo.startDate;
          state.tableParams.libraryIds = ruleInfo.libraryIds;
          nextTick(() => {
            tableRef.value && tableRef.value.refresh();
          });
        }
      },
      { deep: true, immediate: true }
    );
    // const numberall = async () => {
    //   const parms = {
    //     libareId: ruleInfo.libraryIds,
    //     endDate: ruleInfo.endDate,
    //     startDate: ruleInfo.startDate,
    //   };
    //   const res = await suspectedLeave(parms);
    //   state.dataSource = res.page.list;
    //   console.log(res);
    //   return res;
    // };

    const hzTableSelect = (item) => {};
    const handleClick = (item, row) => {};

    return {
      ...refData,
      tableRef,
      formRef,
      queryUserList,
      suspectedLeave,
      hzTableSelect,
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.eventDispatch {
  height: 60vh;
  .tree-card {
    height: 100%;
    width: 100%;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      height: 100%;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
  :deep(.el-input__inner) {
    color: var(--el-text-color-regular) !important;
  }
}
</style>
